import { useTheme } from "@mui/material";

export const useMuiTheme = () => useTheme();
